class ProductUpsell extends HTMLElement {
    constructor() {
      super();
  
      this.upsell = this.querySelector('[name="upsell"]');
      this.priceElements = document.querySelectorAll('.js-price');
      this.currencySymbol = window.currencySymbol || '$';
  
      if (!this.upsell || this.priceElements.length === 0) {
        return;
      }
  
      // Store the base prices for each price element
      this.basePrices = Array.from(this.priceElements).map(priceElement => +priceElement.dataset.price);
      this.upsell.addEventListener('change', () => this.onUpsellChange());
    }
  
    onUpsellChange = () => {
      const upsellPrice = +this.upsell.dataset.price;
      this.priceElements.forEach((priceElement, index) => {
        const basePrice = this.basePrices[index];
        const newPrice = this.upsell.checked ? basePrice + upsellPrice : basePrice;
        priceElement.textContent = `${this.currencySymbol}${newPrice.toFixed(2)}`;
      });
  
      this.classList.toggle('active', this.upsell.checked);
    }
  }
  
  customElements.define('product-upsell', ProductUpsell);